import { makeAutoObservable } from "mobx";
import { UserGON } from "../types";
import { RootStore } from "./root.store";
import { UserAbilities } from "../ability";
import { ROLES } from "../constants";

export interface UserUtilities {
  data: UserGON;
  isCoordinator: () => boolean;
  isViewer: () => boolean;
  isSysAdmin: () => boolean;
  getFullName: () => string;
  getMonogram: () => string;
  hasRole: (id: UserGON["roleId"]) => boolean;
  canDownload: () => boolean;
}

export class UserStore {
  rootStore: RootStore;
  data: UserGON;
  ability: UserAbilities;

  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
    const userData = window.gon.currentUser;
    if (userData) {
      this.data = userData;
      this.ability = new UserAbilities({ role: userData?.roleId || 0 });
    } else {
      this.data = {
        roles: [],
        roleId: 0,
        firstName: "Temporary User",
        lastName: "",
        id: 0,
        email: "",
        canDownload: false,
        categoryIds: [],
        user_group_ids: [],
      };
      this.ability = new UserAbilities({ role: 0 });
    }
  }

  updateUser(userData: UserGON) {
    this.data = userData;
    window.gon.currentUser = userData;
    this.ability = new UserAbilities({ role: userData.roleId });
    this.rootStore.app.setAppReady(true);
  }
}
